import React, { useContext } from 'react';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import { GoDotFill } from 'react-icons/go';
import { Language, LoginUserData } from '../App';
import usePollRemainingTime from '../hooks/usePollRemainingTime';
import { usePollStatus } from '../hooks/usePollStatus';

const PollResultsView = ({ value, toggleModal, removePollAnswer }) => {
  const { lang } = useContext(Language)
  const { splashData } = useContext(LoginUserData);
  const user_id = splashData?.user?.id;
  const showVoteModal = (id) => {
    if (user_id === value?.user?.id) {
      toggleModal(id)
    }

  }
  const remainingTime = usePollRemainingTime(value.time, value.duration);
  const status = usePollStatus(value.time, value.duration);
  const pollActive = status !== lang.poll_closed;
  return (
    <>
      <div className="container my-2">
        {[value?.option_1, value?.option_2, value?.option_3, value?.option_4]
          .filter(data => data !== "" && data !== null)
          .map((data, index) => (
            <div className="list-item-poll mb-2 cursor" key={index}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center no-text-overflow">
                  <span className="me-2">{index + 1}.</span>
                  <span>{data}</span>
                  {value?.right === index + 1 && (
                    <span className="verified-icon">
                      <RiCheckboxCircleFill />
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center ">
                  <div className="avatar-wrapper d-flex">
                  </div>
                  <span className="ms-2">{Array.isArray(value?.percs) && value.percs[index] !== undefined
                    ? `${value.percs[index]}%`
                    : "0%"}</span>
                </div>
              </div>
              <div className="progress-poll mt-2">
                <div
                  className={`progress-bar-poll w-${value?.percs?.[index] ?? 0}`}
                  role="progressbar"
                  aria-valuenow={value?.percs?.[index] ?? 0}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
            </div>
          ))}
      </div>

      <div className="d-flex align-items-center p-2">
        <p
          className="mb-0 cursor custom-margin-color"
          onClick={() => showVoteModal(value.id)}
          
        >
          {value.votes_count} {value.votes_count > 1 ? lang.votes : lang.vote}
        </p>
        {value.duration && <GoDotFill className='text-gray-post' size={10}  />}
        {value.duration && (
          <p className="mb-0 text-muted mx-2">
            {remainingTime}
          </p>
        )}
        {value?.user?.id !== user_id && pollActive &&  (<>
          <GoDotFill className='text-gray-post' size={10} />

          <p
            className="mb-0 cursor custom-ml-color"
            
            onClick={() => removePollAnswer(value.id)}
          >
            {lang.undo}
          </p>
        </>
        )}
      </div>
    </>
  );
};

export default PollResultsView;
